import { render } from "./InfoButton.vue?vue&type=template&id=c8b04f22&scoped=true"
import script from "./InfoButton.vue?vue&type=script&lang=js"
export * from "./InfoButton.vue?vue&type=script&lang=js"

import "./InfoButton.vue?vue&type=style&index=0&id=c8b04f22&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b04f22"]])

export default __exports__